"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("utils");
const errorMessageFromFormErrors_1 = __importDefault(require("./errorMessageFromFormErrors"));
// Generate a flash error message for form submission failures
function flashSubmitFailure(errors, dispatch, submitError) {
    const errorMessage = (0, errorMessageFromFormErrors_1.default)(errors, submitError);
    errorMessage && (0, utils_1.toastError)(errorMessage);
}
exports.default = flashSubmitFailure;
